import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HintManagerService{

  constructor() {
    this._hintText.subscribe((string)=>{
      if (string == null){
        return;
      }
      if (this.timer){
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isTimeoutHint){
        this.timer = setTimeout(()=>{
          this.clearHint();
          this.timer = null;
        }, 5000)
      }
    })
  }

  private timer = null;

  private _hintText: Subject<string> = new Subject<string>();
  get hintText():any{
    return this._hintText.asObservable();
  }
  set hintText(val){
    this._hintText.next(val)
  }
  public isTimeoutHint = true;
  public textColor: string = '#fff';

  public clearHint(){
    this._hintText.next(null);
    this.isTimeoutHint = true;
    this.textColor = '#fff';
  }

}
